import {parsePhoneNumberFromString} from 'libphonenumber-js'
import React, {useEffect, useState} from 'react'
import {
  formatPhoneNumberIntl,
  isPossiblePhoneNumber
} from 'react-phone-number-input'
import {Lang} from 'yougile-lang'
import {availablePhoneCountries} from 'yougile-model'
import {Backend} from '@common/backend'
import {InputNew} from '@components/common/base/input-new/input-new'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'

export const PhoneInput = React.memo(
  ({
    onChange,
    invalid,
    autoFocus,
    support,
    onKeyDown,
    iconRight,
    rightIconClassName
  }: {
    onChange?: ({value, isInvalid}: {value: string; isInvalid: boolean}) => void
    invalid?: boolean
    autoFocus?: boolean
    support?: React.ReactNode
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
    iconRight?: TablerIcons
    rightIconClassName?: string
  }) => {
    const [phoneNumber, setPhoneNumber] = useState('+')
    const [isInvalid, setIsInvalid] = useState(invalid || false)

    useEffect(() => {
      if (invalid !== undefined) {
        setIsInvalid(invalid)
      }
    }, [invalid])

    useEffect(() => {
      const parsedNumber = parsePhoneNumberFromString(phoneNumber)
      const isPhoneValid =
        isPossiblePhoneNumber(phoneNumber) &&
        parsedNumber?.country &&
        (Backend.internationalPhoneNumbers ||
          availablePhoneCountries.includes(parsedNumber.country))

      setIsInvalid(!isPhoneValid)

      if (onChange) {
        onChange({value: phoneNumber, isInvalid: !isPhoneValid})
      }
    }, [phoneNumber, onChange])

    const handlePhoneInputChange = (value: string) => {
      setPhoneNumber(
        !value.startsWith('+') ? `+${value.replace(/\+/g, '')}` : value
      )
    }

    const formattedPhone = formatPhoneNumberIntl(phoneNumber)

    return (
      <InputNew
        autoFocus={autoFocus}
        value={formattedPhone ? formattedPhone : phoneNumber}
        error={phoneNumber !== '+' && isInvalid}
        support={support}
        label={Lang.msg.users.phone}
        onChange={handlePhoneInputChange}
        onKeyDown={onKeyDown}
        iconRight={iconRight}
        rightIconClassName={rightIconClassName}
      />
    )
  }
)
